import { PGlobalMenuItemKeys } from '@previo/design-system'
import type { CountryStrategyInterface } from '~/layouts/components/l10n/countries/CountryStrategyInterface'
import type { Routes } from '~/router/routes'

export class DefaultCountryStrategy implements CountryStrategyInterface {
  public readonly statOfficeReportsRoute: Routes | null = null

  isMenuPointDisabled(menuPoint: PGlobalMenuItemKeys): boolean {
    switch (menuPoint) {
      case PGlobalMenuItemKeys.NTAK_GROUP:
      case PGlobalMenuItemKeys.VISA_GROUP:
      case PGlobalMenuItemKeys.MANAGER_REPORTS_NTAK_KPI:
        return true
      default:
        return false
    }
  }
}
